import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {showToastMessage} from "../../../modules/toast";
import {showAlertMessage} from "../../../modules/alert";
import {OPEN_EXTERNAL_LINK, ENCODE_QUERY_DATA, COPY_TO_CLIPBOARD, NAVER_THUMBNAIL_GETTER} from "../../../modules/variable/common_variable";


class ShareActionSheet extends React.Component {
    state = {
        shareActionSheet: {
            open: true
        },
        websiteHelperActionSheet: {open: false, linkUrl: '', iframeTag: ''}
    };

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps){

    }

    triggerKakaoLink = () => {
        const target = this.props.target;
        OPEN_EXTERNAL_LINK('https://picnicisub.firebaseapp.com/kakao_link.html?docId=' + target.DOC_ID);
    };

    triggerNaverShare = () => {
        const url = encodeURI(this.getScheduleLinkUrl());
        const title = encodeURI(this.props.target.title);
        let shareURL = "https://share.naver.com/web/shareView.nhn?url=" + url + "&title=" + title;
        OPEN_EXTERNAL_LINK(shareURL);
    };

    triggerFacebookShare = () => {
        let url = this.getScheduleLinkUrl();
        //let shareURL = "https://m.facebook.com/v3.2/dialog/share?appId=562456444257311&app_id=562456444257311&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D43%23cb%3Df1674c325b942%26domain%3Dpici.com%26origin%3Dhttp%253A%252F%252Fpici.com%253A8887%252Ff353641636c662c%26relation%3Dopener&display=popup&e2e=%7B%7D&fallback_redirect_uri=http%3A%2F%2Fpici.com%3A8887%2F%2Ffacebook_share.html&href=" + url + "&locale=en_US&mobile_iframe=false&next=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D43%23cb%3Df239d63e2311218%26domain%3Dpici.com%26origin%3Dhttp%253A%252F%252Fpici.com%253A8887%252Ff353641636c662c%26relation%3Dopener%26frame%3Df2735039b529a38%26result%3D%2522xxRESULTTOKENxx%2522&sdk=joey&version=v3.2&_rdc=1&_rdr";
        let shareURL = "https://www.facebook.com/sharer/sharer.php?u=" + url;
        OPEN_EXTERNAL_LINK(shareURL);
    };

    triggerTwitterShare = () => {
        const target = this.props.target;
        const title = target.title;
        let url = window.location.origin + '/schedule?docId=' + this.props.target.DOC_ID;
        let ds = [];
        for(let i = 0; i < target.scheduleOrder.length; i ++){
            const schedule = target.schedule[target.scheduleOrder[i]];
            ds.push(schedule.name);
        }
        let hashtags = ds.join(',');
        let query = {url: url, hashtags: hashtags, text: title};

        let shareURL = "https://twitter.com/share?" + ENCODE_QUERY_DATA(query);
        OPEN_EXTERNAL_LINK(shareURL);
    };

    getScheduleLinkUrl() {
        const target = this.props.target;
        let ds = [];
        for(let i = 0; i < target.scheduleOrder.length; i ++){
            const schedule = target.schedule[target.scheduleOrder[i]];
            ds.push(schedule.name);
        }
        let description = ds.join(',');
        let ts = target.schedule[target.scheduleOrder[target.thumbnailIndex ? target.thumbnailIndex : 0]];
        let image = ts.imageSrc;
        let title = target.title;

        let url = encodeURIComponent(window.location.origin + '/scheduleWithMetaTag?docId=' + this.props.target.DOC_ID + "&title=" + title + "&description=" + description + "&image=" + image);
        return url;
    }

    openWebsiteHelperActionSheet = () => {
        let url = window.location.origin + '/schedule?docId=' + this.props.target.DOC_ID;
        let iframe = "<iframe width='100%' height='512px' src='" + url + "'></iframe>";

        this.setState({websiteHelperActionSheet: {linkUrl: url, iframeTag: iframe, open: true}});
    };

    render() {
        const SAS = this.state.shareActionSheet;

        return (
            <div>
                <ActionSheet className="share-action-sheet" isOpen={SAS.open} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material">
                        일정 공유하기
                    </div>
                    <ul className="list list--material">
                        <li className="list-item list-item--material" onClick={() => this.triggerNaverShare()}>
                            <div className="list-item__left list-item--material__left">
                                <img className="list-item__thumbnail"
                                     src={'/assets/image/logo/naver_icon_green.png'}
                                     alt={'naver_icon_white'}/>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">네이버</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material" onClick={() => this.triggerKakaoLink()}>
                            <div className="list-item__left list-item--material__left">
                                <img className="list-item__thumbnail"
                                     src={'/assets/image/logo/kakaolink_btn_medium.png'}
                                     alt={'kakaolink_btn_medium'}/>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">카카오톡</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material" onClick={() => this.triggerFacebookShare()}>
                            <div className="list-item__left list-item--material__left">
                                <i className="fa fa-facebook"></i>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">페이스북</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material" onClick={() => this.triggerTwitterShare()}>
                            <div className="list-item__left list-item--material__left">
                                <i className="fa fa-twitter"></i>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">트위터</div>
                            </div>
                        </li>
                        {/*<li className="list-item list-item--material">
                            <div className="list-item__left list-item--material__left">
                                <i className="fa fa-instagram"></i>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">인스타그램</div>
                            </div>
                        </li>*/}
                        <li className="list-item list-item--material" onClick={this.openWebsiteHelperActionSheet}>
                            <div className="list-item__left list-item--material__left">
                                <img className="list-item__thumbnail"
                                     src={'/assets/image/logo/grid-world.png'}
                                     alt={'grid-world'}
                                    style={{width: '15px', height: '15px'}}
                                />
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">웹사이트</div>
                            </div>
                        </li>
                    </ul>
                    <ActionSheetButton className="action-sheet-close TUTO_CLOSE_SHARE_BUTTON" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>일정 공유 닫기</ActionSheetButton>
                </ActionSheet>

                {
                    this.state.websiteHelperActionSheet.open ?
                        <ActionSheet className="share-action-sheet" isOpen={this.state.websiteHelperActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({websiteHelperActionSheet: {...this.state.websiteHelperActionSheet, open: false}})} isCancelable={true}>
                            <div>
                                <ul className="list--material list">
                                    <li className="list-header list-header--material">
                                        링크 URL
                                    </li>
                                    <li className="list-item list-item--material">
                                        <div className="list-item__center list-item--material__center">
                                            <div id="share-link-url" className="list-item__title">{this.state.websiteHelperActionSheet.linkUrl}</div>
                                        </div>
                                        <div className="list-item__right list-item--material__right">
                                            <button className="button button--material--flat" onClick={() => COPY_TO_CLIPBOARD('share-link-url', '링크 URL', this.props)}>복사하기</button>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list--material list">
                                    <li className="list-header list-header--material">
                                        iFrame 태그
                                    </li>
                                    <li className="list-item list-item--material">
                                        <div className="list-item__center list-item--material__center">
                                            <div id="share-iframe-tag" className="list-item__title">{this.state.websiteHelperActionSheet.iframeTag}</div>
                                        </div>
                                        <div className="list-item__right list-item--material__right">
                                            <button className="button button--material--flat" onClick={() => COPY_TO_CLIPBOARD('share-iframe-tag', 'iFrame 태그', this.props)}>복사하기</button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({websiteHelperActionSheet: {...this.state.websiteHelperActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>웹사이트 공유 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }
            </div>
            )
    }
}

const mapStateToProps = ({ user, native }) => ({
    userInfo: user.userInfo,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ShareActionSheet))

